class MediaStreamConfigurableStatic {
    constructor(theStream, theConfig) {
        this.theStream = theStream;
        this.theConfig = theConfig;
    }

    config() {
        return this.theConfig;
    }

    stream() {
        return this.theStream;
    }
}

export default MediaStreamConfigurableStatic;
